import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import DialogAssigneeSelect from "~/operatorApplication/vue/dialogs/dialog/sidemenu/DialogAssigneeSelect.vue";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import {ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {
    EVENT_OPEN_CROSS_OPERATOR_CONVERSATION_TAB,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {__} from "~/ts/library/Translate";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";

import OperatorMessageSetDialogStatusAssignedOpenApiModel = OperatorApplicationApi.OperatorMessageSetDialogStatusAssignedOpenApiModel;
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;
import OperatorApplicationClientCrossOperatorConversationParamsOpenApiModel = OperatorApplicationApi.OperatorApplicationClientCrossOperatorConversationParamsOpenApiModel;
import StartCrossOperatorClientConversationResultOpenApiModel = OperatorApplicationApi.StartCrossOperatorClientConversationResultOpenApiModel;

const __default__ = {
    name: "CrossOperatorConversationConfig"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    currentParams: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let defaultLogins = [OperatorAccountStore.login.value];
let lastDialog = props.userdata.lastDialog;
if (lastDialog) {
    for (let login of lastDialog.operatorLogins) {
        toggleArrayElement(defaultLogins, login, true);
    }
}


let model = ref<OperatorApplicationClientCrossOperatorConversationParamsOpenApiModel>((props.currentParams ? ObjectHelper.jsonClone(props.currentParams) : undefined) ?? {
    operatorLogins: defaultLogins,
    operatorGroupIds: [],
    parentSiteId: props.userdata.siteId,
    parentUsername: props.userdata.username
});

function onAssignedInput(e: OperatorMessageSetDialogStatusAssignedOpenApiModel) {
    model.value.operatorLogins = e.operatorLogins;
    model.value.operatorGroupIds = e.groupIds;
}

let visible = _useModel<boolean>(__props, "visible");


async function apply() {
    let username = props.userdata.crossOperatorConversationUsername;
    if (!username) {
        let p: OperatorApplicationApi.StartCrossOperatorClientConversationOpenApiModel = {
            username: props.userdata.username
        };
        let result = await (new OperatorApiRequest({
            url: "/buddyList/startCrossOperatorClientConversation",
            p
        })).send();
        if (!result.showMessageOnError()) {
            visible.value = false;
            let data = result.data as StartCrossOperatorClientConversationResultOpenApiModel;
            username = data.username;
        }
    }
    if (username) {
        let p: OperatorApplicationApi.UpdateCrossOperatorClientConversationParamsOpenApiModel = {
            username,
            operatorLogins: model.value.operatorLogins,
            operatorGroupIds: model.value.operatorGroupIds
        };
        let result = await (new OperatorApiRequest({
            url: "/buddyList/updateCrossOperatorClientConversationParams",
            p
        })).send();
        result.showMessageOnError();
    }
    OperatorApplicationEventManager.emit(
        EVENT_OPEN_CROSS_OPERATOR_CONVERSATION_TAB,
        props.userdata.username
    );
    visible.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createBlock(MyDialog, {
        key: 0,
        visible: _unref(visible),
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
        title: __props.userdata.crossOperatorConversationUsername ? _unref(__)('Настройки обсуждения') : _unref(__)('Начать обсуждение'),
        onApply: apply
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "Выберите участников обсуждения", -1)),
          _createElementVNode("p", null, [
            _createVNode(DialogAssigneeSelect, {
              userdata: __props.userdata,
              "model-value": {
                    operatorLogins: _unref(model).operatorLogins,
                    groupIds: _unref(model).operatorGroupIds
                },
              "onUpdate:modelValue": onAssignedInput
            }, null, 8, ["userdata", "model-value"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]))
    : _createCommentVNode("", true)
}
}

})